import Loading from "./Loading";

## Basic Usage

<Loading />

---

## Variants

<div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Icon only:**</p>
    <Loading variant="icon" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Fill container:**</p>
    <div style={{ height: "100px", border: "1px dashed #ccc", position: "relative" }}>
      <Loading variant="fill" />
    </div>
  </div>
</div>

---

## Sizes

<div style={{ display: "flex", alignItems: "flex-start", gap: "2rem" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Base:**</p>
    <Loading size="base" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Medium:**</p>
    <Loading size="medium" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Large:**</p>
    <Loading size="large" />
  </div>
</div>

---

## Custom Text

<div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
  <Loading text="Loading..." />
  <Loading text="Please wait" />
  <Loading text="Saving changes" />
  <Loading text={<span style={{ color: "#3b82f6" }}>Processing</span>} />
</div>

---

## Text Position

<div style={{ display: "flex", gap: "3rem" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Below (default):**</p>
    <Loading text="Loading" textPosition="below" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Above:**</p>
    <Loading text="Loading" textPosition="above" />
  </div>
</div>

---

## Direction

<div style={{ display: "flex", gap: "3rem" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Column (default):**</p>
    <Loading text="Loading" direction="column" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Row:**</p>
    <Loading text="Loading" direction="row" />
  </div>
</div>

---

## Custom Spinner Size

<div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
  <Loading spinnerSize={12} text="Small" />
  <Loading spinnerSize={18} text="Default" />
  <Loading spinnerSize={32} text="Large" />
</div>

---

## In Context

<div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "2rem", textAlign: "center" }}>
  <Loading text="Loading your data..." />
</div>


